import { Flame, Leaf, Users } from 'lucide-react';

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-brand-cream py-24 md:py-36 px-6 md:px-12 lg:px-16 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Text */}
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p
            data-testid="about-eyebrow"
            className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-burgundy mb-6"
          >
            About Us
          </p>
          <h2
            data-testid="about-heading"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-brand-coffee tracking-tight"
          >
            Where authentic
            <br />
            South Indian flavours{' '}
            <span className="italic text-brand-burgundy">come to life</span>.
          </h2>

          <p
            data-testid="about-paragraph"
            className="mt-8 text-base md:text-lg text-brand-mocha leading-[1.8] max-w-xl"
          >
            Welcome to Sankalp Restaurant Sunshine Coast, where authentic South Indian
            flavours come to life. Renowned for our signature dosas and traditional
            delicacies, we serve freshly prepared dishes made with quality ingredients
            for an unforgettable dine-in, takeaway, or delivery experience.
          </p>

          <div className="mt-12 grid sm:grid-cols-3 gap-6">
            <Stat icon={<Flame className="w-5 h-5" />} title="Signature Dosas" sub="Hand-spread, crispy" />
            <Stat icon={<Leaf className="w-5 h-5" />} title="Fresh Daily" sub="Hand-ground spices" />
            <Stat icon={<Users className="w-5 h-5" />} title="Family Dining" sub="Warm hospitality" />
          </div>
        </div>

        {/* Image collage */}
        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="relative grid grid-cols-12 grid-rows-6 gap-4 h-[460px] md:h-[560px]">
            <div className="col-span-8 row-span-4 rounded-2xl overflow-hidden shadow-[0_30px_60px_rgba(43,27,23,0.18)]">
              <img
                src="https://images.pexels.com/photos/35351659/pexels-photo-35351659.jpeg"
                alt="Crispy masala dosa with chutney"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]"
              />
            </div>
            <div className="col-span-4 row-span-3 rounded-2xl overflow-hidden col-start-9 shadow-[0_20px_40px_rgba(43,27,23,0.14)]">
              <img
                src="https://images.pexels.com/photos/31199041/pexels-photo-31199041.jpeg"
                alt="Idli with sambar"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]"
              />
            </div>
            <div className="col-span-5 row-span-2 rounded-2xl overflow-hidden row-start-5 shadow-[0_20px_40px_rgba(43,27,23,0.14)]">
              <img
                src="https://images.pexels.com/photos/38201893/pexels-photo-38201893.png"
                alt="Uttapam with chutney"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]"
              />
            </div>
            <div className="col-span-7 row-span-3 rounded-2xl overflow-hidden col-start-6 row-start-4 shadow-[0_20px_40px_rgba(43,27,23,0.14)]">
              <img
                src="https://images.pexels.com/photos/28909536/pexels-photo-28909536.jpeg"
                alt="Biryani"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]"
              />
            </div>
            {/* Gold accent badge */}
            <div className="absolute -left-4 -bottom-6 md:-left-8 md:-bottom-8 w-28 h-28 md:w-36 md:h-36 rounded-full bg-brand-gold text-brand-coffee flex flex-col items-center justify-center text-center shadow-2xl rotate-[-6deg]">
              <span className="font-serif text-3xl md:text-4xl leading-none">est.</span>
              <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-bold mt-1">
                Sankalp
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ icon, title, sub }) => (
  <div className="flex flex-col gap-2 border-t border-brand-coffee/15 pt-5">
    <span className="w-9 h-9 rounded-full bg-brand-burgundy/10 text-brand-burgundy flex items-center justify-center">
      {icon}
    </span>
    <span className="font-serif text-lg text-brand-coffee">{title}</span>
    <span className="text-sm text-brand-mocha">{sub}</span>
  </div>
);

export default About;
